import { render, staticRenderFns } from "./ClubPromoWidget.vue?vue&type=template&id=3df6c1c2&scoped=true"
import script from "./ClubPromoWidget.vue?vue&type=script&lang=js"
export * from "./ClubPromoWidget.vue?vue&type=script&lang=js"
import style0 from "./ClubPromoWidget.vue?vue&type=style&index=0&id=3df6c1c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df6c1c2",
  null
  
)

export default component.exports